import axios, { AxiosResponse } from "axios"

import { axiosConfigAuth } from "../middleware"
import {
    API_AUTOCALL_SOURCES,
    API_CALL_GET_DATA,
    API_CALL_SEND,
    API_CALL_SET_STATUS,
    API_CIAN_COOKIES_SAVE,
    API_USER_GET_INFO,
    API_USER_GET_LOCATIONS,
    API_USER_GET_STATUS,
    API_USER_PHOTO_BALANCE,
    API_USER_UPDATE_LOCATIONS,
    API_USER_UPDATE_STATUS
} from "../urls"

export const mainApi = {
    getUserInfo: (): Promise<AxiosResponse> => {
        return axios.get(API_USER_GET_INFO, axiosConfigAuth())
    },

    getUserStatus: (): Promise<AxiosResponse> => {
        return axios.get(API_USER_GET_STATUS, axiosConfigAuth())
    },
    getUserPhotoBalance: (): Promise<AxiosResponse> => {
        return axios.get(API_USER_PHOTO_BALANCE,axiosConfigAuth())
    },

    getUserLocations: (): Promise<AxiosResponse> => {
        return axios.get(API_USER_GET_LOCATIONS, axiosConfigAuth())
    },

    updateUserStatus: (status: 2 | 4): Promise<AxiosResponse> => {
        return axios.get(`${API_USER_UPDATE_STATUS}/${status}`, axiosConfigAuth())
    },

    updateUserLocations: (values: { id: number, name: string, status: boolean }[]): Promise<AxiosResponse> => {
        return axios.post(API_USER_UPDATE_LOCATIONS, values, axiosConfigAuth())
    },

    sendCallStatus: (id: number | string, status: number, note: string, operator_id?: number): Promise<AxiosResponse> => {
        const data = {
            id: String(id),
            status_id: status,
            notes: note,
        }
        const newData = operator_id ? {
            ...data,
            operator_id: operator_id,
        } : data

        return axios.post(API_CALL_SET_STATUS, newData, axiosConfigAuth())
    },

    fetchCallData: (id: number | string): Promise<AxiosResponse> => {
        return axios.get(`${API_CALL_GET_DATA}/${id}`, axiosConfigAuth())
    },

    sendCall: (id: number | string): Promise<AxiosResponse> => {
        return axios.get(`${API_CALL_SEND}/${id}`, axiosConfigAuth())
    },

    // CIAN Cookies
    saveCianCookies: (cookies: string): Promise<AxiosResponse> => {
        return axios.post(API_CIAN_COOKIES_SAVE, { cookies }, axiosConfigAuth())
    },

    // Autocall Sources
    saveAutocallSources: (sources: number[]): Promise<AxiosResponse> => {
        return axios.post(API_AUTOCALL_SOURCES, { sources }, axiosConfigAuth())
    }
}
